module.exports = __webpack_public_path__ + "img/icon5.b0e6ded0.png";